<template>
    <v-dialog v-model="model" :max-width="1000">
        <v-card v-if="model">

            <toolbar-page :title="createMode ? 'Create new supplier' : 'Update supplier'" help="external-supplier-dialog">

                <template slot="buttons">

                    <v-btn v-if="createMode" @click="saveClicked" color="primary" :loading="saving">
                        Create
                    </v-btn>

                    <v-btn v-if="!createMode" @click="saveClicked" color="primary" :loading="saving">
                        Update
                    </v-btn>

                    <v-btn fab color="error" elevation="0" x-small dark @click="closeDialogClicked()" class="ml-3">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>

                </template>

            </toolbar-page>

            <validation-observer ref="validationObserver" v-slot="{ invalid, errors }">

                <v-tabs class="text-left"
                        :show-arrows="false"
                        slider-color="primary"
                        color="white"
                        v-model="activeTab">

                    <v-tab key="tab1">
                        Info
                    </v-tab>

                    <v-tab key="tabb">
                        Links
                    </v-tab>

                    <!-- SUPPLIER INFO TAB -->
                    <v-tab-item eager key="tab1" reverse-transition="fade-transition" transition="fade-transition">

                        <v-card-text class="pt-0">

                            <title-card class="pt-4" title="Settings" side-icon="mdi-network-outline">

                                <v-row dense>
                                    <v-col cols="6">
                                        <validation-provider
                                            name="Name"
                                            rules="min:3|max:50|required"
                                            mode="lazy"
                                            v-slot="{ errors }">

                                            <v-text-field v-model="form.name"
                                                          dense
                                                          hint="Supplier name"
                                                          persistent-hint
                                                          :error-messages="errors"
                                            ></v-text-field>

                                        </validation-provider>
                                    </v-col>

                                </v-row>
                            </title-card>

                            <title-card class="pt-4" title="Primary contact" side-icon="mdi-card-account-details">

                                <v-row dense>

                                    <v-col cols="12">
                                        <validation-provider
                                            name="primary contact name"
                                            rules="min:3|max:50"
                                            mode="lazy"
                                            v-slot="{ errors }">

                                            <v-text-field v-model="form.primary_contact_name"
                                                          dense
                                                          hint="Primary contact name"
                                                          persistent-hint
                                                          :error-messages="errors"
                                                          prepend-icon="mdi-account"
                                            ></v-text-field>
                                        </validation-provider>
                                    </v-col>

                                    <v-col cols="12">
                                        <validation-provider
                                            name="primary contact email"
                                            rules="min:3|max:50|email"
                                            mode="lazy"
                                            v-slot="{ errors }">

                                            <v-text-field v-model="form.primary_contact_email"
                                                          dense
                                                          hint="Primary contact email"
                                                          persistent-hint
                                                          prepend-icon="mdi-at"
                                                          :error-messages="errors"
                                            ></v-text-field>
                                        </validation-provider>
                                    </v-col>

                                    <v-col cols="12">
                                        <validation-provider
                                            name="primary contact phone"
                                            rules="min:3|max:50"
                                            mode="lazy"
                                            v-slot="{ errors }">

                                            <v-text-field v-model="form.primary_contact_phone"
                                                          dense
                                                          hint="Primary contact phone"
                                                          persistent-hint
                                                          prepend-icon="mdi-phone"
                                                          :error-messages="errors"
                                            ></v-text-field>
                                        </validation-provider>
                                    </v-col>
                                </v-row>
                            </title-card>

                            <div style="height: 128px"></div>

                        </v-card-text>

                    </v-tab-item>

                    <!-- SUPPLIER LINKS TAB -->
                    <v-tab-item eager key="tab2" reverse-transition="fade-transition" transition="fade-transition">

                        <v-card-text class="pt-0">

                            <!-- ENTRY LINK -->
                            <title-card class="pt-4" title="Entry link" side-icon="mdi-link">

                                <div>
                                    <validation-provider
                                        name="unique identifier parameter"
                                        rules="required|alpha_num|min:1|max:30"
                                        mode="lazy"
                                        v-slot="{ errors }">

                                        <v-text-field v-model="form.unique_identifier_param"
                                                      class="body-2"
                                                      dense
                                                      hint="Unique identifier parameter"
                                                      prepend-icon="mdi-account-key"
                                                      :error-messages="errors"
                                                      persistent-hint
                                                      @input="updateEntryLink"
                                        ></v-text-field>
                                    </validation-provider>
                                </div>
                                <div>
                                    <v-text-field v-model="form.entry_link"
                                                  class="body-2"
                                                  dense
                                                  disabled
                                                  hint="Entry link"
                                                  placeholder="Entry link"
                                                  prepend-icon="mdi-link"
                                                  persistent-hint
                                    ></v-text-field>
                                </div>
                            </title-card>

                            <!-- EXIT LINKS -->
                            <title-card class="pt-4" title="Exit links" side-icon="mdi-link">

                                <div class="d-flex">

                                    <v-icon v-if="paramErrors.completed_link.length > 0" color="yellow darken-2">mdi-alert</v-icon>
                                    <v-icon v-else color="grey lighten-1">mdi-link</v-icon>

                                    <div class="ml-2 flex-grow-1">
                                        <validation-provider
                                            name="completed link"
                                            rules="url|required|max:1000"
                                            mode="lazy"
                                            v-slot="{ errors }">

                                            <v-text-field v-model="form.completed_link"
                                                          class="body-2"
                                                          dense
                                                          hint="Complete link"
                                                          placeholder="Complete link"
                                                          :error-messages="errors"
                                                          @change="updateEntryLink"
                                                          persistent-hint
                                            ></v-text-field>

                                        </validation-provider>
                                    </div>
                                </div>

                                <div class="d-flex">
                                    <v-icon v-if="paramErrors.profile_link.length > 0" color="yellow darken-2">mdi-alert</v-icon>
                                    <v-icon v-else color="grey lighten-1">mdi-link</v-icon>

                                    <div class="ml-2 flex-grow-1">
                                        <validation-provider
                                            name="profile link"
                                            rules="url|required|max:1000"
                                            mode="lazy"
                                            v-slot="{ errors }">

                                            <v-text-field v-model="form.profile_link"
                                                          class="body-2"
                                                          dense
                                                          hint="Profile link"
                                                          placeholder="Profile link"
                                                          :error-messages="errors"
                                                          @change="updateEntryLink"
                                                          persistent-hint
                                            ></v-text-field>

                                        </validation-provider>
                                    </div>
                                </div>

                                <div class="d-flex">
                                    <v-icon v-if="paramErrors.quota_link.length > 0" color="yellow darken-2">mdi-alert</v-icon>
                                    <v-icon v-else color="grey lighten-1">mdi-link</v-icon>

                                    <div class="ml-2 flex-grow-1">
                                        <validation-provider
                                            name="quota link"
                                            rules="url|required|max:1000"
                                            mode="lazy"
                                            v-slot="{ errors }">

                                            <v-text-field v-model="form.quota_link"
                                                          class="body-2"
                                                          dense
                                                          hint="Quota link"
                                                          placeholder="Quota link"
                                                          :error-messages="errors"
                                                          @change="updateEntryLink"
                                                          persistent-hint
                                            ></v-text-field>

                                        </validation-provider>
                                    </div>
                                </div>

                                <div class="d-flex">
                                    <v-icon v-if="paramErrors.quality_link.length > 0" color="yellow darken-2">mdi-alert</v-icon>
                                    <v-icon v-else color="grey lighten-1">mdi-link</v-icon>

                                    <div class="ml-2 flex-grow-1">
                                        <validation-provider
                                            name="quality link"
                                            rules="url|required|max:1000"
                                            mode="lazy"
                                            v-slot="{ errors }">

                                            <v-text-field v-model="form.quality_link"
                                                          class="body-2"
                                                          dense
                                                          hint="Quality link"
                                                          placeholder="Quality link"
                                                          :error-messages="errors"
                                                          @change="updateEntryLink"
                                                          persistent-hint
                                            ></v-text-field>
                                        </validation-provider>
                                    </div>
                                </div>

                                <div class="d-flex">
                                    <v-icon v-if="paramErrors.duplicate_link.length > 0" color="yellow darken-2">mdi-alert</v-icon>
                                    <v-icon v-else color="grey lighten-1">mdi-link</v-icon>

                                    <div class="ml-2 flex-grow-1">

                                        <validation-provider
                                            name="duplicate link"
                                            rules="url|required|max:1000"
                                            mode="lazy"
                                            v-slot="{ errors }">
                                            <v-text-field v-model="form.duplicate_link"
                                                          class="body-2"
                                                          dense
                                                          hint="Duplicate link"
                                                          placeholder="Duplicate link"
                                                          :error-messages="errors"
                                                          @change="updateEntryLink"
                                                          persistent-hint
                                            ></v-text-field>
                                        </validation-provider>
                                    </div>
                                </div>

                                <div class="d-flex">
                                    <v-icon v-if="paramErrors.security_link.length > 0" color="yellow darken-2">mdi-alert</v-icon>
                                    <v-icon v-else color="grey lighten-1">mdi-link</v-icon>

                                    <div class="ml-2 flex-grow-1">

                                        <validation-provider
                                            name="security link"
                                            rules="url|required|max:1000"
                                            mode="lazy"
                                            v-slot="{ errors }">
                                            <v-text-field v-model="form.security_link"
                                                          class="body-2"
                                                          dense
                                                          hint="Security link"
                                                          placeholder="Security link"
                                                          :error-messages="errors"
                                                          @change="updateEntryLink"
                                                          persistent-hint
                                            ></v-text-field>
                                        </validation-provider>
                                    </div>
                                </div>
                            </title-card>
                        </v-card-text>
                    </v-tab-item>
                </v-tabs>
            </validation-observer>

            <json v-if="false" :data="form"></json>

        </v-card>
    </v-dialog>
</template>

<script>

import Json from 'vue-json-pretty';
import ToolbarPage from "../../../components/UI/ToolbarPage";
import TitleCard from "../../../components/UI/TitleCard";
import {extend} from 'vee-validate/dist/vee-validate.full';
import {mapActions} from 'vuex';

const vuexModule = 'ExternalSuppliers';

export default {

    components: {
        TitleCard,
        ToolbarPage,
        Json
    },

    props: {
        value: {
            required: true,
            type: Boolean,
        },
        subPanels: {
            required: true,
            type: Array
        },
        data: {
            required: false,
            type: Object | null,
            default: () => {
                return {
                    id: null,
                    name: 'New supplier',
                    unique_identifier_param: 'unique',
                    enabled: true,
                    primary_contact_name: '',
                    primary_contact_email: '',
                    primary_contact_phone: '',
                    entry_link: '',
                    completed_link: '',
                    profile_link: '',
                    quota_link: '',
                    quality_link: '',
                    duplicate_link: '',
                    security_link: '',
                }
            }
        }
    },

    watch: {
        data() {
            this.form = Object.assign({}, this.data);
            this.updateEntryLink();
        }
    },

    data() {
        return {
            saving: false,
            paramErrors: {
                'completed_link': [],
                'profile_link': [],
                'quota_link': [],
                'quality_link': [],
                'duplicate_link': [],
                'security_link': [],
            },
            form: {},
            params: [],
            activeTab: 0,
            links: ['completed_link', 'profile_link', 'quota_link', 'quality_link', 'duplicate_link','security_link'],
        }
    },

    computed: {

        model: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },

        createMode() {
            return !this.data.id;
        }
    },

    methods: {
        ...mapActions(vuexModule, [
            'createSupplier',
            'updateSupplier'
        ]),

        hasError(name) {
            return !!this.paramErrors.find(n => n === name);
        },

        saveClicked() {
            this.$refs.validationObserver.validate()
                .then(isValid => {
                    if (isValid) {
                        this.emit();

                        if (this.createMode) {
                            this.doCreate();
                        } else {
                            this.doUpdate();
                        }
                    } else {
                        Bus.$emit('flash-message', {type: 'error', message: 'Validation failed. Please review the form.'});
                    }
                })
        },

        doCreate() {
            this.saving = true;

            this.createSupplier(this.form)
                .then(response => {
                    Bus.$emit('flash-message', {type: 'info', message: 'Supplier saved!'});
                    this.closeDialogClicked();
                })
                .catch(error => {
                    this.displayErrors(error);
                })
                .finally(() => {
                    this.saving = false;
                })
        },

        doUpdate() {
            this.saving = true;

            this.updateSupplier(this.form)
                .then(response => {
                    Bus.$emit('flash-message', {type: 'info', message: 'Supplier updated!'});
                    this.closeDialogClicked();
                })
                .catch(error => {
                    this.displayErrors(error);
                })
                .finally(() => {
                    this.saving = false;
                })
        },

        displayErrors(error) {
            if (error.response.status === 422) {
                Bus.$emit('flash-message', {
                    type: 'error',
                    message: 'Supplier validation failed. Please review the supplier information entered.'
                });
            } else {
                Bus.$emit('flash-message', {
                    type: 'error',
                    message: 'OOPS. We failed to save the supplier. Please try again.'
                });
            }
        },

        closeDialogClicked() {
            this.$emit('input', false);
        },

        updateEntryLink() {

            this.params = [];

            let previousErrorFound = false;

            this.links.forEach(name => {

                const url = this.form[name];

                let parsedUrl = null;

                try {
                    parsedUrl = new URL(url);
                } catch (e) {
                    // Do nothing regular validation should pick this up
                }

                if (parsedUrl !== null) {
                    for (const [key, value] of parsedUrl.searchParams.entries()) {

                        if (value.charAt(0) === '[' && value.charAt(value.length - 1) === ']') {

                            const found = this.params.find(param => param.key === key);

                            if (!found) this.params.push({
                                key: key,
                                value: value
                            });

                            const variableName = value.substring(1, value.length - 1);

                            if (key !== variableName) {

                                const prettyLinkName = this.ucFirst(name.replace('_', ' '));
                                const errorMessage = `In ${prettyLinkName} ${key} -parameter should match the variable name: ${variableName}`;

                                // Display first error only
                                if (previousErrorFound === false) {

                                    Bus.$emit('flash-message', {
                                        type: 'error',
                                        message: errorMessage
                                    });
                                }

                                this.paramErrors[name] = [];
                                this.paramErrors[name].push(errorMessage);

                                previousErrorFound = true;
                            } else {
                                this.paramErrors[name] = [];
                            }
                        }
                    }
                }
            });

            previousErrorFound = false;

            let entryLink = window.location.protocol + '://' +
                window.location.hostname + '/supplier/xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxxx';

            const found = this.params.find(param => param.key === this.form.unique_identifier_param);

            let assembledParameters = [];

            if (!found) {
                assembledParameters.push(this.form.unique_identifier_param + '=' + '[' + this.form.unique_identifier_param + ']');
            }

            assembledParameters = [...assembledParameters, ...this.params.map(param => param.key + '=' + param.value)];

            entryLink += '?' + assembledParameters.join('&');

            this.form.entry_link = entryLink;
        },

        emit() {
            this.$emit('change', this.form);
        }
    },

    mounted() {

        extend('url', {
            validate(value) {

                try {
                    const parsedUrl = new URL(value);
                    return new RegExp('^https:\/\/[0-9a-z-.]+\.[a-z]+$').test(parsedUrl.origin);
                } catch (e) {
                    return false;
                }

            },
            message: "Valid URL is required and must begin with https://"
        });

        if (this.data) {
            this.form = Object.assign({}, this.data);
            this.updateEntryLink();
        }
    }
}
</script>
